module.exports = __webpack_public_path__ + "media/images/weather/30_day-688dbe8eee86c83b1f6165ed459406b3.png";